import axios from 'axios';

const state = {
	giftcards: [],
	giftcard: {},
	index: '',
	sortBy: '',
	sortDesc: '',
	setting: {},
};

const getters = {
	getGiftcards: state => state.giftcards,
	getGiftcard: state => state.giftcard,
	getIndex: state => state.index,
	getSortBy: state => state.sortBy,
	getSortDesc: state => state.sortDesc,
	getSetting: state => state.setting,
};

const actions = {
	asyncFetchData: async (context, settings) => {
		context.commit('setSetting', settings);
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		const url = 'giftcard';
		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: sortBy[0],
						sortDesc: sortDesc[0],
						page,
						itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				context.commit('setGiftcards', res.data.data);
				return res.data.pagination;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},

	destroyData: context => {
		context.commit('setGiftcards', []);
		context.commit('setGiftcard', {});
		context.commit('setIndex', '');
	},
};

const mutations = {
	setGiftcards: (state, value) => {
		state.giftcards = value;
	},
	setGiftcard: (state, value) => {
		state.giftcard = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
	setSetting: (state, value) => {
		state.setting = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
